const statusMap = (customerStatus) => {
    const status = customerStatus?.toLowerCase();
    switch (status) {
        case 'active':
        case 'trialing':
            return 'is-success';
        case 'inactive':
        case 'unpaid':
        case 'incomplete':
            return 'is-danger';
        case 'paused':
        case 'suspended':
        case 'past_due':
            return 'is-warning';
        default:
            return 'is-light';
    }
}

const CustomerStatusTag = ({ customer, className = '' }) => {
    const status = customer.stripe?.main_subscription_status || 'No Stripe';
    const statusColor = statusMap(status);

    return (
        <span className={`tag is-uppercase ${statusColor} ${className}`}>
            {status}
        </span>
    );
}

export { CustomerStatusTag };
